import { getToken, getUserId } from "../Common/utils/auth";
import { BASE_URL } from "../Common/constant";
import axios from "axios";

export const fetchUserProfile = async () => {
    try {
        const result = await axios.post(BASE_URL + "user/find",
            {
                "user_id": getUserId()
            },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                }
            });
        return result.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const updateUserProfile = async (userData: any) => {
    try {
        const result = await axios.post(BASE_URL + "user/update",
            {
                "email": userData.email,
                "dob": userData.dob,
                "city": userData.city,
                "mobile": userData.mobile
            },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                }
            });
        return result.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const updatePassword = async (passwordData: any) => {
    try {
        const result = await axios.post(BASE_URL + "user/changepassword",
            {
                "user_id": getUserId(),
                "old_password": passwordData.old_password,
                "new_password": passwordData.new_password
            },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                }
            });
        return result.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const uploadProfilePhoto = async (formData: FormData) => {
    try {
        const response = await fetch(BASE_URL + "user/uploadprofilephoto",
            {
                method: 'POST',
                body: formData
            },
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const logoutUser = async () => {
    try {
        const result = await axios.post(BASE_URL + "user/logout",
            {},
            {
                headers: {
                    encryption: false,
                    token: getToken()
                }
            });
        return result.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};